import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import imageCompression from "browser-image-compression";

import {
  db,
  storage,
} from "../firebase";

import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

import "../styles/JoinAuto.css";

const SERVICE_AREAS = [
  "Sankagiri",
  "Pallipalayam",
  "Kumarapalayam",
  "Tiruchengode",
  "Veppadai",
];

export default function JoinAuto() {

  const navigate = useNavigate();
  const { user } = useAuth();

  const [driver, setDriver] = useState(null);

  const [preview, setPreview] = useState("");

  const [loading, setLoading] = useState(false);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);

  const [driverName, setDriverName] = useState("");
  const [mobile, setMobile] = useState("");
  const [autoNumber, setAutoNumber] = useState("");
  const [license, setLicense] = useState("");
  const [serviceArea, setServiceArea] = useState("");
  const [photo, setPhoto] = useState(null);

  

  useEffect(() => {
  if (!user) return;

  loadUser();
  checkRegistration();
}, [user]);

useEffect(() => {
  return () => {
    if (preview) {
      URL.revokeObjectURL(preview);
    }
  };
}, [preview]);

async function loadUser() {
  try {
    const snap = await getDoc(doc(db, "users", user.uid));

    if (snap.exists()) {
      const data = snap.data();

      setDriverName(data.name || user.displayName || "");
      setMobile(data.mobile || "");
    } else {
      setDriverName(user.displayName || "");
    }
  } catch (err) {
    console.error(err);
  }
}

  async function checkRegistration() {
  const snap = await getDoc(doc(db, "autos", user.uid));

  if (snap.exists()) {
    setAlreadyRegistered(true);

    const data = snap.data();

    setDriver(data);

    setDriverName(data.driverName);
    setMobile(data.mobile);
    setAutoNumber(data.autoNumber);
    setLicense(data.license || "");
    setServiceArea(data.serviceArea || "");
    setPreview(data.photo || "");
  }
}

async function updatePhoto() {

  if (!photo) {
    alert("Select a photo first.");
    return;
  }

  setLoading(true);

  try {

    const compressed = await imageCompression(photo, {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    });

    const imageRef = ref(
      storage,
      `autos/${user.uid}.jpg`
    );

    await uploadBytes(imageRef, compressed);

    const url = await getDownloadURL(imageRef);

    await setDoc(
      doc(db, "autos", user.uid),
      {
        photo: url,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    setPreview(url);

    alert("✅ Profile photo updated.");

  } catch (err) {

    console.error(err);

    alert("Failed to update photo.");

  }

  setLoading(false);

}

  async function handleSubmit(e) {

    e.preventDefault();

    if (!user) {

      alert("Please login first.");
      return;

    }

    if (alreadyRegistered) {

      alert("You are already registered.");

      navigate("/auto-dashboard");

      return;

    }

    if (
      !driverName ||
      !mobile ||
      !autoNumber ||
      !serviceArea
    ) {

      alert("Please fill all required fields.");

      return;

    }

    setLoading(true);

    try {

      let photoURL = "";

      if (photo) {

        const imageRef = ref(
          storage,
          `autos/${user.uid}.jpg`
        );

        const compressed = await imageCompression(photo, {
  maxSizeMB: 0.3,
  maxWidthOrHeight: 800,
  useWebWorker: true,
});

await uploadBytes(imageRef, compressed);

        photoURL = await getDownloadURL(imageRef);

      }

      await setDoc(doc(db, "autos", user.uid), {

    uid: user.uid,

    driverName,

    mobile,

    autoNumber,

    license,

    serviceArea,

    photo: photoURL,

    available: true,

    online: false,

    verified: false,

    rating: 5,

    totalTrips: 0,

    totalEarned: 0,

    completedTrips: 0,

    cancelledTrips: 0,

    joinedAt: serverTimestamp(),

    createdAt: serverTimestamp(),

    updatedAt: serverTimestamp()

});


      alert(
        "Application submitted successfully.\nWaiting for admin approval."
      );

      navigate("/auto-dashboard");

    }

    catch (err) {

      console.error(err);

      alert(err.message);

    }

    setLoading(false);

  }

  if (alreadyRegistered) {

  return (

    <div className="join-auto-page">

      <h2>🚖 My Auto Profile</h2>

      <div className="driver-profile-card">

        <img
          src={preview || "https://via.placeholder.com/150?text=Driver"}
          className="photo-preview"
          alt=""
        />

        <label className="change-photo-btn">

          📷 Change Photo

          <input
            hidden
            type="file"
            accept="image/*"
            onChange={(e) => {

              const file = e.target.files[0];

              if (!file) return;

              setPhoto(file);

              setPreview(URL.createObjectURL(file));

            }}
          />

        </label>

        <button
          className="join-btn"
          onClick={updatePhoto}
          disabled={loading}
        >

          {loading ? "Updating..." : "Update Photo"}

        </button>

        <input
          value={driverName}
          readOnly
        />

        <input
          value={mobile}
          readOnly
        />

        <input
          value={autoNumber}
          readOnly
        />

        <input
          value={license}
          readOnly
        />

        <input
          value={serviceArea}
          readOnly
        />

        <div
  className={
    driver?.verified
      ? "status-box verified"
      : "status-box"
  }
>
  {driver?.verified
    ? "✅ Verified"
    : "⏳ Waiting for Approval"}
</div>

      </div>

    </div>

  );

}

  return (

    <div className="join-auto-page">

      <h2>🚖 Join as Auto Driver</h2>

     
    <p>

        Register your auto and start receiving ride requests
        from nearby customers.

    </p>



      <form
        className="join-auto-form"
        onSubmit={handleSubmit}
      >

        <input
          type="text"
          placeholder="Driver Name"
          value={driverName}
          onChange={(e) =>
            setDriverName(e.target.value)
          }
          required
        />

        <input
    type="tel"
    value={mobile}
    readOnly
/>

        <input
          type="text"
          placeholder="Auto Number"
          value={autoNumber}
          onChange={(e) =>
            setAutoNumber(
  e.target.value
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, "")
    .replace(/\s+/g, " ")
)
          }
          required
        />

        <input
          type="text"
          placeholder="Driving License (Optional)"
          value={license}
          onChange={(e) =>
            setLicense(e.target.value)
          }
        />

        <select
          value={serviceArea}
          onChange={(e) =>
            setServiceArea(e.target.value)
          }
          required
        >

          <option value="">
            Select Service Area
          </option>

          {SERVICE_AREAS.map(area => (

            <option
              key={area}
              value={area}
            >
              {area}
            </option>

          ))}

        </select>

        <label>

          Driver Photo

          <input
  type="file"
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files[0];

    if (!file) return;

    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  }}
/>

{preview && (
  <img
    src={preview}
    alt="Preview"
    className="photo-preview"
  />
)}

        </label>

        <button
    className="join-btn"
    disabled={loading}
>

    {loading ? "Please wait..." : "Become Auto Partner"}

</button>

      </form>

    </div>

  );

}